module.exports = {
  langText: {
    en: { Wind: 'Wind', Humidity: 'Humidity' },
    es: { Wind: 'Viento', Humidity: 'Humedad' },
  },
};
